export default __webpack_public_path__ + "static/media/photo-1503467913725-8484b65b0715.95ccd4b9.jpeg";